import { render, staticRenderFns } from "./TableMedia.vue?vue&type=template&id=0366f6dc"
import script from "./TableMedia.vue?vue&type=script&lang=js"
export * from "./TableMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports